import React from "react";
import {
  backgroundLight,
  newBorder,
  primaryAlt,
  textPrimary,
  textSecondary,
  white,
} from "../../../utils/colors";
import { Box, Button, Flex, Icon, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { TbEye } from "react-icons/tb";
import { Link } from "react-router-dom";

const TreatmentPlanSendingPatientPortalInfo = ({ tenant, treatmentPlan }) => {
  const { t } = useTranslation();

  return (
    <>
      <Flex align="center" justify="flex-start" w="100%" m="0 0 1rem">
        <Flex w="100%" direction="column" align="flex-start" justify="center">
          <Text
            fontSize="sm"
            fontWeight="500"
            color={textPrimary}
            m="0 0 0.25rem"
          >
            {t("patient.patientPortalInfo")}:
          </Text>

          <Box
            border={`1px solid ${newBorder}`}
            p="1.5rem"
            borderRadius="1.5rem"
            w="100%"
          >
            <Text
              fontSize="sm"
              fontWeight="500"
              color={textSecondary}
              pr="0rem"
            >
              {t("patient.patientPortalSentInfo")}
            </Text>

            <Text
              m="1rem 0 0"
              fontSize="0.8rem"
              fontWeight="500"
              color={textSecondary}
              pr="0rem"
            >
              {t("patient.patientPortalSentInfoVisiblePlans", {
                plansVisible:
                  treatmentPlan?.patient?.totalTreatmentPlansAvailablePublic,
              })}
            </Text>

            <Link
              to={`/${tenant.slug}/portal/patient/${treatmentPlan?.patient?._id}`} // Adjust the URL as needed
              target="_blank"
            >
              <Button
                size="md"
                fontSize="0.8rem"
                m="1rem 0 0"
                // fontWeight="500"
                bg={backgroundLight}
                color={textSecondary}
                borderRadius="1rem"
                _hover={{
                  bg: textPrimary,
                  color: white,
                }}
              >
                {t("patient.patientPortalButtonLabel")}
              </Button>
            </Link>
          </Box>

          {/* <Flex w="100%" borderRadius="1.5rem" p="1rem 0rem" direction="column">
            <Text
              fontSize="sm"
              color={textSecondary}
              fontWeight="500"
              m="0rem 0 1rem"
              pr="2rem"
            >
              {t("patient.patientPortalDescription", {
                count: 0,
              })}
            </Text>

            <Flex align="center" w="100%" gap="0.5rem">
              <Link target="_blank">
                <Button
                  size="lg"
                  fontSize="0.8rem"
                  bg={backgroundLight}
                  color={textSecondary}
                  borderRadius="1rem"
                  _hover={{
                    bg: textPrimary,
                    color: white,
                  }}
                >
                  {t("patient.patientPortalButtonLabel")}
                </Button>
              </Link>
            </Flex>
          </Flex> */}
        </Flex>
      </Flex>
    </>
  );
};

export default TreatmentPlanSendingPatientPortalInfo;
